import { useMenuDeleteStore } from '../../hooks';
import { MenuDeleteModalView } from '../../components/MenuDeleteModalView';

export const MenuDeleteModal = () => {
  const deleteStore = useMenuDeleteStore();

  return <MenuDeleteModalView {...deleteStore} />;
};
